
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { AlertTriangle, Shield } from "lucide-react";
import { useLanguage } from "@/contexts/useLanguage";

interface DeviceVerificationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
  isLoading?: boolean;
}

export const DeviceVerificationDialog = ({
  isOpen,
  onClose,
  onProceed,
  isLoading = false
}: DeviceVerificationDialogProps) => {
  const { t } = useLanguage();

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Shield className="h-5 w-5 text-warning" />
            {t("auth.deviceVerification.title")}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-left">
            {t("auth.deviceVerification.description")}

            <div className="mt-3 p-3 rounded-lg border bg-muted/50">
              <div className="flex items-center gap-2 text-sm">
                <AlertTriangle className="h-4 w-4 text-warning" />
                <span className="font-medium">{t("auth.deviceVerification.securityNotice")}</span>
              </div>
              <p className="text-sm text-muted-foreground mt-1">
                {t("auth.deviceVerification.verificationCodeMessage")}
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="flex-col sm:flex-row gap-2">
          <AlertDialogCancel onClick={onClose} className="w-full sm:w-auto">
            {t("common.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onProceed}
            disabled={isLoading}
            className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90"
          >
            {isLoading ? t("auth.deviceVerification.processing") : t("auth.deviceVerification.continueVerification")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
